import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

const CloseIcon = React.forwardRef<SVGSVGElement, Props>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...props} ref={ref}>
    <path
      d="M13 13L7.00002 7.00002M7.00002 7.00002L1 1M7.00002 7.00002L13 1M7.00002 7.00002L1 13"
      stroke="#0F131A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

CloseIcon.displayName = 'CloseIcon';

export default CloseIcon;
